import React from "react";
import QRCode from "react-qr-code";
import { formatMoney, formatDate } from "utils";

const pageStyle = {
  width: "210mm",
  minHeight: "297mm",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  padding: "16px",
  backgroundColor: "#ffffff",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridTemplateRows: "1fr 1fr",
  gap: "12px",
  flex: 1,
};

const FONT = "'Montserrat', sans-serif";

const cellStyle = {
  border: "1px dashed #bbb",
  borderRadius: "12px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 2px 10px rgba(0,0,0,0.10)",
  backgroundColor: "#1b2f4e",
  fontFamily: FONT,
};

const headerStyle = {
  padding: "20px 16px 18px",
  textAlign: "center",
  color: "#ffffff",
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

const bodyStyle = {
  backgroundColor: "#ffffff",
  borderRadius: "14px 14px 0 0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "16px 20px 14px",
  gap: 10,
  flex: 1,
};

const VoucherCard = ({ voucher, batchName, qrDataUrl }) => (
  <div style={cellStyle}>
    <div style={headerStyle}>
      <span style={{ fontSize: 22, fontWeight: "bold" }}>Parabéns!</span>
      <span style={{ fontSize: 12, opacity: 0.9 }}>Você ganhou</span>
      <span style={{ fontSize: 26, fontWeight: "bold", fontStyle: "italic" }}>
        {formatMoney(voucher.amount)}
      </span>
      <span style={{ fontSize: 12, opacity: 0.9 }}>
        da campanha {voucher._name || batchName}
      </span>
    </div>
    <div style={bodyStyle}>
      {qrDataUrl ? (
        <img src={qrDataUrl} alt="QR Code" style={{ width: 130, height: 130 }} />
      ) : (
        <QRCode value={voucher.link} size={130} />
      )}
      <p style={{ fontSize: 12, color: "#394D6D", textAlign: "center", margin: 0, lineHeight: 1.5, fontWeight: 600 }}>
        Escaneie o QR Code<br />e resgate seu prêmio
      </p>
      <p style={{ fontSize: 11, color: "#666", margin: 0 }}>
        Válido até: {formatDate(voucher.expirationDate)} 📅
      </p>
    </div>
  </div>
);

const RewardVoucherQrCodePrint = React.forwardRef(({ vouchers, batchName, qrDataUrls }, ref) => {
  const pages = [];
  for (let i = 0; i < vouchers.length; i += 4) {
    pages.push(vouchers.slice(i, i + 4));
  }

  return (
    <div ref={ref}>
      {pages.map((page, pageIndex) => (
        <div key={pageIndex} data-pdf-page style={pageStyle}>
          {batchName && (
            <div style={{ textAlign: "center", marginBottom: 12 }}>
              <span style={{ fontSize: 22, fontWeight: "bold", fontStyle: "italic", letterSpacing: 1 }}>
                {batchName.toUpperCase()}
              </span>
            </div>
          )}
          <div style={gridStyle}>
            {page.map((voucher) => (
              <VoucherCard
                key={voucher.id}
                voucher={voucher}
                batchName={batchName}
                qrDataUrl={qrDataUrls?.[voucher.id]}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
});

RewardVoucherQrCodePrint.displayName = "RewardVoucherQrCodePrint";

export { RewardVoucherQrCodePrint };
